import { DropdownDataType, ProviderGames } from "../models";

interface OptionalParams {
  labelKey?: string;
  valueKey?: string;
  disabledKey?: string;
  additionalLabelKey?: string,
  additionalStaticLabel?: string,
  translate?: (key: string) => string;
}

//TODO refactor
export const gamesDataToDropDownConverter = (
  data: Array<ProviderGames>,
): Array<DropdownDataType> => {
  return data.map((data: any) => ({
    value: data.gameId,
    label: data.gameName,
  }));
};

export const dataToDropDownConverter = (data: Array<Record<string, any>>, options?: OptionalParams): Array<DropdownDataType> => {
  const labelKey = options?.labelKey || "label";
  const valueKey = options?.valueKey || "value";
  const disabledKey = options?.disabledKey || "disabled";
  const additionalLabelKey = options?.additionalLabelKey || "additionalLabel";

  const translate = options?.translate;

  return data.map((data) => ({
    ...data,
    value: data[valueKey],
    disabled: !!data[disabledKey],
    additionalLabel: data[additionalLabelKey],
    label: translate ? translate(data[labelKey]) : data[labelKey],
  }));
};
